export function CoreSetLoadedCtrl ($scope) {
  $scope.loaded = true;
}